import * as React from "react";

import NavBar from "./navBar";

const PageHeader = ({ activePage, children }) => {
  return (
    <div className="relative   bg-white overflow-hidden">
      <div className="max-w-7xl    mx-auto ">
        <div className="relative  pb-8 bg-white   lg:max-w-2xl lg:w-full ">
          <svg
            className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2"
            fill="currentColor"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <polygon points="50,0 100,0 50,100 0,100" />
          </svg>

          <div className=" ">
            <NavBar activePage={activePage} />
          </div>
        </div>
      </div>
      <main className=" ">{children}</main>
    </div>
  );
};

export default PageHeader;
